import React, { useContext, useState } from 'react';
import { Button } from 'antd';
import { FormikProvider, useFormik } from 'formik';
import { Form, SubmitButton } from 'formik-antd';
import RegularInput from '../CustomInput/RegularInput';
import './Modals.scss';
import '../UserPage/UserPage.scss';
import PageHeader from '../PageHeader/PageHeader';
import SignIn from '../../model/SignIn';
import { useHistory } from 'react-router-dom';
import { Context } from '../../index';
import { observer } from 'mobx-react-lite';

const PersonalArea = (): JSX.Element => {
  const history = useHistory();
  const { store } = useContext(Context);
  if (store.isAuth) {
    history.push('/personal-area');
  }
  const [error, setError] = useState<string>('');

  const formik = useFormik({
    initialValues: {
      login: '',
      password: '',
    },
    onSubmit: (values, actions) => {
      const signIn: SignIn = {
        email: values.login,
        password: values.password,
      };
      store.login(signIn).then(
        () => history.push('/personal-area'),
        (e) => {
          setError(e);
        }
      );
      actions.setSubmitting(false);
      actions.resetForm();
    },
  });

  return (
    <>
      {!store.isAuth && (
        <div className="userPage">
          <PageHeader title="Личный кабинет" />
          <div className="userPage__content">
            <FormikProvider value={formik}>
              <Form className="userPage__form">
                <div className={`personalArea__error ${error ? 'active' : ''}`}>
                  <p>Введены неверные данные</p>
                </div>
                <RegularInput
                  width={''}
                  placeholder="Логин"
                  label="E-mail"
                  required={true}
                  type="text"
                  name="login"
                  value={formik.values.login}
                  onChange={formik.handleChange}
                  autoFocus
                />
                <RegularInput
                  width={''}
                  placeholder="Введите пароль"
                  label="Пароль"
                  required={true}
                  name="password"
                  type="password"
                  value={formik.values.password}
                  onChange={formik.handleChange}
                />
                <div className="divider" />
                <Button.Group>
                  <SubmitButton
                    className="loginButton"
                    disabled={
                      formik.values.login === '' ||
                      formik.values.password === ''
                    }
                  >
                    Войти
                  </SubmitButton>
                  <Button
                    className="registerButton"
                    onClick={() => {
                      history.push('/register');
                    }}
                  >
                    Зарегистрироваться
                  </Button>
                  <a href={'/restore'}>Забыли пароль?</a>
                </Button.Group>
              </Form>
            </FormikProvider>
          </div>
        </div>
      )}
    </>
  );
};

export default observer(PersonalArea);
